import React, { useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import { Environment } from 'utils/environment';
import { RolesList } from '../Tools';
import { useTypedSelector } from 'hooks';
import Typography from '@material-ui/core/Typography';
import { Box, Paper, Grid, Card, CardContent, Fade } from '@material-ui/core';
import { Person, WorkOutline, CheckCircleOutline } from '@mui/icons-material';

export const Home = () => {
  const mySession = useTypedSelector((s) => s.session);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const user = mySession.user;
  const roleName = RolesList.find((w) => w.id === user?.role.name)?.name;

  return (
    <Container component="main" maxWidth="md" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
      <Fade in={mounted} timeout={800}>
        <Paper
          elevation={8}
          style={{
            padding: '48px 40px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }}
        >
          {/* Logo Section */}
          <Box textAlign="center" mb={4}>
            {!Environment.hideMarks && (
                <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div style={{ width: '200px' }}>
                <img
                  src={process.env.PUBLIC_URL + 'Logo2.png'}
                  alt="App Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }} />
              </div>
            </Box>
            )}
            <Typography
              variant="h3"
              style={{
                fontWeight: 700,
                fontSize: '32px',
                color: '#343c89',
                marginBottom: '8px',
              }}
            >
              GEO {Environment.Country}
            </Typography>
          </Box>

          {/* Welcome Section */}
          {mySession.isLoading ? (
            <Box display="flex" justifyContent="center" padding="40px">
              <CircularProgress style={{ color: '#343c89' }} size={48} />
            </Box>
          ) : (
            <Box>
              {/* Welcome Message */}
              <Box
                style={{
                  background: 'linear-gradient(135deg, #343c89 0%, #4a5aaa 100%)',
                  padding: '32px',
                  borderRadius: '12px',
                  marginBottom: '32px',
                  boxShadow: '0 4px 20px rgba(52, 60, 137, 0.2)',
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '28px',
                    marginBottom: '8px',
                  }}
                >
                  ¡Bienvenido!
                </Typography>
                <Typography
                  variant="h5"
                  style={{
                    color: 'rgba(255, 255, 255, 0.95)',
                    fontWeight: 500,
                    fontSize: '22px',
                  }}
                >
                  {user?.name} {user?.lastName}
                </Typography>
              </Box>

              {/* Info Cards */}
              <Grid container spacing={3}>
                {/* Role Card */}
                <Grid item xs={12} md={6}>
                  <Card
                    elevation={3}
                    style={{
                      borderRadius: '12px',
                      height: '100%',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'default',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(52, 60, 137, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
                    }}
                  >
                    <CardContent style={{ padding: '24px' }}>
                      <Box display="flex" alignItems="center" mb={2}>
                        <Box
                          style={{
                            backgroundColor: 'rgba(52, 60, 137, 0.1)',
                            borderRadius: '50%',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '16px',
                          }}
                        >
                          <WorkOutline style={{ color: '#343c89', fontSize: '28px' }} />
                        </Box>
                        <Box>
                          <Typography variant="body2" style={{ color: '#666', fontSize: '14px' }}>
                            Rol actual
                          </Typography>
                          <Typography
                            variant="h6"
                            style={{
                              color: '#343c89',
                              fontWeight: 600,
                              fontSize: '18px',
                            }}
                          >
                            {roleName}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* User Info Card */}
                <Grid item xs={12} md={6}>
                  <Card
                    elevation={3}
                    style={{
                      borderRadius: '12px',
                      height: '100%',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'default',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(52, 60, 137, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
                    }}
                  >
                    <CardContent style={{ padding: '24px' }}>
                      <Box display="flex" alignItems="center" mb={2}>
                        <Box
                          style={{
                            backgroundColor: 'rgba(14, 129, 75, 0.1)',
                            borderRadius: '50%',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '16px',
                          }}
                        >
                          <Person style={{ color: '#0e814b', fontSize: '28px' }} />
                        </Box>
                        <Box>
                          <Typography variant="body2" style={{ color: '#666', fontSize: '14px' }}>
                            Usuario
                          </Typography>
                          <Typography
                            variant="h6"
                            style={{
                              color: '#0e814b',
                              fontWeight: 600,
                              fontSize: '18px',
                            }}
                          >
                            {user?.userName}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Status Message */}
        
            </Box>
          )}

          {/* Error Message */}
          {mySession.error?.name && (
            <Box
              style={{
                marginTop: '24px',
                padding: '16px 20px',
                borderRadius: '12px',
                backgroundColor: '#f8d7da',
                border: '1px solid #f5c6cb',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '24px',
                  flexShrink: 0,
                }}
              >
                ⚠️
              </span>
              <Typography
                variant="body2"
                style={{
                  color: '#721c24',
                  fontWeight: 500,
                  fontSize: '14px',
                }}
              >
                {mySession.error.message}
              </Typography>
            </Box>
          )}
        </Paper>
      </Fade>

      {/* Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Container>
  );
};
